// Lišta s obsahem košíku dole na mobilu (zobrazení jen do 767 px řeší CSS)
function myStickyCartTexts() {
    return $.extend({
        cart: "V košíku",
        unit: "ks",
        button: "Přejít do košíku",
    }, (typeof shopDataLayer !== "undefined" && shopDataLayer.stickyCart) || {});
}

function myStickyCartUpdate() {
    const $bar = $(".mysticky-cart");
    let amount = 0;

    $.each(getShoptetDataLayer("cart") || [], function (index, item) {
        amount += parseFloat(item.quantity) || 0;
    });

    const price = $("#header .cart-count .cart-price").first().text().trim();

    if (amount > 0) {
        $bar.find(".mysticky-cart-amount").text(Math.round(amount * 1000) / 1000 + " " + myStickyCartTexts().unit);
        $bar.find(".mysticky-cart-price").text(price);
        $bar.removeClass("no-display");
        $("body").addClass("mysticky-cart-visible");
    } else {
        $bar.addClass("no-display");
        $("body").removeClass("mysticky-cart-visible");
    }
}

$(document).ready(function () {
    // Košík a pokladna mají vlastní souhrn
    if ($("body").is(".ordering-process, .id--9, .id--15, .id--16, .id--17")) {
        return;
    }

    const texts = myStickyCartTexts();
    const href = $("#header .cart-count").attr("href") || "/kosik/";

    $("<div class='mysticky-cart no-display'>" +
        "<div class='mysticky-cart-info'>" +
            "<span class='mysticky-cart-label'>" + texts.cart + "</span>" +
            "<span class='mysticky-cart-summary'>" +
                "<span class='mysticky-cart-amount'></span>" +
                "<span class='mysticky-cart-price'></span>" +
            "</span>" +
        "</div>" +
        "<a class='mysticky-cart-button' href='" + href + "' rel='nofollow'>" + texts.button + "</a>" +
    "</div>").appendTo("body");

    myStickyCartUpdate();
});

document.addEventListener("ShoptetCartUpdated", function () {
    if ($(".mysticky-cart").length) {
        myStickyCartUpdate();
    }
});
